import { render } from "./CGL.vue?vue&type=template&id=15b8427a"
import script from "./CGL.vue?vue&type=script&lang=js"
export * from "./CGL.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/gr2022-phase-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__